export const siteInfo = {
  name: '51黑料网',
  htmlTitle: '51黑料网 | 51黑料网一区二区与每日大赛 | 黑料一区 黑料二区 黑料大赛专区 黑料分区内容 最新导航入口',
  heroTag: '全网最全黑料分区导航',
  heroTitle: '51黑料网 · 一区二区每日大赛',
  heroSlogan: '按区浏览，一手黑料不错过',
  heroIntro: '51黑料网是国内领先的黑料分区内容导航平台，汇聚一区二区、每日大赛专区等核心分类入口，每日更新海量黑料分区内容。无论您是关注黑料一区的最新动态，还是追踪黑料二区的热门事件，亦或是参与黑料大赛专区的实时讨论，这里都能为您提供最及时、最全面的分区浏览体验。本站采用分区管理模式，确保内容精准分类、快速直达，让每一位用户都能高效获取感兴趣的黑料信息。',
  heroStats: [
    { label: '日更新内容', value: '300+' },
    { label: '覆盖热门事件', value: '全天候' },
    { label: '分区精准导航', value: '即时直达' },
  ],
  heroCtaPrimary: { text: '立即进入一区', href: '#cards' },
  heroCtaSecondary: { text: '查看每日大赛', href: '#ranking' },
};

export const contactData = {
  title: '联系我们',
  desc: '欢迎通过以下方式联系我们进行内容投稿、合作咨询或意见反馈。51黑料网持续开放一区二区及每日大赛专区的投稿通道，期待您的黑料分区内容加入。',
  items: [
    { icon: 'ri-mail-line', label: '投稿邮箱', value: 'tougao@51heilia.com' },
    { icon: 'ri-wechat-line', label: '合作微信', value: '51heilia_official' },
    { icon: 'ri-phone-line', label: '客服热线', value: '400-888-5151' },
  ],
};

export const commentsData = {
  title: '读者热评',
  items: [
    {
      avatar: '匿',
      name: '匿名用户A',
      time: '2小时前',
      content: '一区的内容更新真快，每天都有新瓜吃，这个分区导航太方便了！黑料一区的整理非常到位，推荐给身边的朋友了。',
      tag: '黑料一区',
    },
    {
      avatar: '匿',
      name: '吃瓜群众K',
      time: '5小时前',
      content: '每日大赛专区简直是宝藏板块，各种热门事件的汇总做得太专业了。黑料大赛的评选机制也很有意思。',
      tag: '每日大赛',
    },
    {
      avatar: '匿',
      name: '匿名用户W',
      time: '8小时前',
      content: '二区的内容深度很好，不止是简单搬运，还有背景分析和时间线整理。希望黑料二区继续保持这个更新频率。',
      tag: '黑料二区',
    },
  ],
};

export const cardsData = {
  title: '热门黑料',
  items: [
    {
      img: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20newsroom%20theme%20with%20warm%20amber%20accent%20lighting%2C%20editorial%20composition%20with%20typewriter%20and%20documents%2C%20mysterious%20atmosphere%2C%20cinematic%20lighting%2C%20professional%20journalism%20aesthetic%20with%20deep%20shadows%20and%20warm%20highlights&width=800&height=500&seq=card-01&orientation=landscape',
      tag: '黑料一区',
      title: '全网独家深度爆料：某知名网红背后团队运作内幕全记录',
      desc: '详细梳理事件来龙去脉，从多方信源交叉验证，还原事件真相。包含时间线梳理、关键人物关系图谱及后续发展预测。',
      date: '2026-07-28',
      hot: '9.8万',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20scene%20with%20warm%20ceramic%20textures%2C%20subtle%20amber%20and%20terracotta%20tones%2C%20dramatic%20shadow%20play%2C%20investigative%20journalism%20atmosphere%2C%20minimalist%20composition%20with%20document%20fragments%2C%20professional%20news%20aesthetic&width=800&height=500&seq=card-02&orientation=landscape',
      tag: '每日大赛',
      title: '每日大赛第47期：本周最劲爆话题评选结果揭晓',
      desc: '本周共有128个话题参与角逐，经过用户投票和评审团综合评定，最终选出十大热门话题。榜首话题引发全网热议。',
      date: '2026-07-27',
      hot: '12.3万',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Warm%20dark%20archive%20room%20with%20amber%20desk%20lamp%20lighting%2C%20vintage%20files%20and%20newspapers%2C%20mysterious%20investigative%20atmosphere%2C%20rich%20texture%20of%20aged%20paper%2C%20professional%20documentary%20style%20photography%2C%20deep%20shadows&width=800&height=500&seq=card-03&orientation=landscape',
      tag: '黑料二区',
      title: '黑料二区深度追踪：某平台数据造假事件持续发酵',
      desc: '二区编辑团队持续跟进该事件进展，已收集多方证据材料，整理了完整的事件链。涉事平台尚未作出正面回应。',
      date: '2026-07-26',
      hot: '8.5万',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Atmospheric%20dark%20study%20with%20warm%20copper%20and%20brass%20accents%2C%20scattered%20photographs%20and%20notes%2C%20dramatic%20single%20light%20source%2C%20noir%20investigative%20aesthetic%2C%20rich%20textures%20of%20leather%20and%20wood%2C%20professional%20cinematic%20composition&width=800&height=500&seq=card-04&orientation=landscape',
      tag: '黑料一区',
      title: '一区首发：娱乐圈年度最大合同纠纷独家内幕曝光',
      desc: '涉及多位知名艺人与经纪公司的合约纠纷细节被一区独家获取，包含合同条款分析、利益分配机制解密及后续走向研判。',
      date: '2026-07-25',
      hot: '15.6万',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Moody%20warm%20toned%20investigative%20office%20with%20amber%20glass%20and%20metal%20details%2C%20papers%20spread%20across%20surface%2C%20dramatic%20overhead%20lighting%2C%20film%20noir%20atmosphere%2C%20professional%20newsroom%20aesthetic%2C%20rich%20dark%20with%20warm%20highlights&width=800&height=500&seq=card-05&orientation=landscape',
      tag: '每日大赛',
      title: '每日大赛八月预热：下月话题风向标抢先看',
      desc: '编辑部根据近期舆情走势和用户关注度数据，预测八月将出现三大话题集群。提前锁定这些方向，不错过任何精彩内容。',
      date: '2026-07-24',
      hot: '6.2万',
    },
  ],
};

export const rankingData = {
  title: '热度榜单',
  items: [
    { rank: 1, title: '某知名MCN机构内部管理混乱内幕', zone: '黑料一区', hot: '🔥 28.6万', trend: 'up' },
    { rank: 2, title: '直播平台刷量黑产链条完整起底', zone: '黑料二区', hot: '🔥 24.1万', trend: 'up' },
    { rank: 3, title: '每日大赛第46期冠军话题回顾盘点', zone: '每日大赛', hot: '🔥 19.8万', trend: 'same' },
    { rank: 4, title: '某明星代言品牌涉嫌虚假宣传追踪', zone: '黑料一区', hot: '17.3万', trend: 'up' },
    { rank: 5, title: '社交平台算法推荐机制深度解析', zone: '黑料二区', hot: '14.5万', trend: 'down' },
  ],
};

export const faqData = {
  title: '常见问题',
  items: [
    {
      q: '51黑料网的一区二区有什么区别？',
      a: '黑料一区主要聚焦娱乐、网红、明星等公众人物的相关内容与深度爆料；黑料二区则侧重互联网平台、商业机构、行业动态等方面的信息追踪与分析。两大分区各有侧重，用户可根据兴趣选择浏览。',
    },
    {
      q: '每日大赛专区如何参与？',
      a: '每日大赛专区每天更新热门话题评选，用户可通过评论区参与讨论。每周最受关注的话题将进入周度大赛评比，月度冠军话题将获得专属展示位。当前为静态展示期，更多互动功能敬请期待。',
    },
    {
      q: '如何向51黑料网投稿？',
      a: '您可以通过页面上的联系方式（#contact区域）发送邮件至投稿邮箱，投稿时请注明所属分区（一区/二区/每日大赛）并附上相关素材。我们的编辑团队将在24小时内审核回复。',
    },
    {
      q: '51黑料网的内容更新频率如何？',
      a: '网站保持全天候内容监控与更新，一区二区每日至少更新30条以上内容，每日大赛专区每日准时更新评选结果。重大突发事件将在30分钟内完成信息汇总并发布。',
    },
  ],
};

export const topicsData = {
  title: '话题广场',
  items: [
    { name: '网红翻车', count: '3.2万讨论', hot: true },
    { name: '平台内幕', count: '2.8万讨论', hot: true },
    { name: '明星合约', count: '2.5万讨论', hot: true },
    { name: '数据造假', count: '2.1万讨论', hot: false },
    { name: '直播黑产', count: '1.9万讨论', hot: true },
    { name: 'MCN揭秘', count: '1.7万讨论', hot: false },
    { name: '代言风波', count: '1.5万讨论', hot: false },
    { name: '算法透明', count: '1.3万讨论', hot: false },
    { name: '行业乱象', count: '1.2万讨论', hot: true },
    { name: '内容审核', count: '1.0万讨论', hot: false },
    { name: '流量买卖', count: '0.9万讨论', hot: false },
  ],
};

export const appData = {
  title: '移动端入口',
  desc: '51黑料网移动端适配已全面完成，在手机浏览器中直接访问本站即可获得最佳浏览体验。所有分区内容、每日大赛更新及话题讨论均可在移动端流畅查看，无需额外下载应用。',
  features: ['即时推送更新', '夜间模式适配', '一键切换分区', '流畅阅读体验'],
};

export const featuresData = {
  title: '平台特色',
  items: [
    {
      icon: 'ri-folder-history-line',
      title: '分区清晰',
      desc: '一区二区与每日大赛三大专区独立运营，内容分类精准，用户可按兴趣快速定位目标分区，避免信息混杂。',
    },
    {
      icon: 'ri-timer-flash-line',
      title: '更新及时',
      desc: '全天候内容监控体系，确保热点事件发生后30分钟内完成信息汇总发布，让用户第一时间掌握最新黑料动态。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '信源可靠',
      desc: '坚持多方信源交叉验证原则，每条内容均经过编辑团队审核，确保信息的真实性和完整性。',
    },
    {
      icon: 'ri-group-line',
      title: '社区活跃',
      desc: '每日大赛专区聚集大量活跃用户参与讨论评选，形成高质量的内容社区氛围，话题热度持续走高。',
    },
  ],
};

export const aboutData = {
  title: '关于我们',
  intro: '51黑料网成立于2024年，是国内领先的黑料分区内容导航平台。我们致力于为广大用户提供及时、全面、精准的黑料分区内容服务，涵盖黑料一区、黑料二区及黑料大赛专区三大核心板块。平台以分区管理模式为核心特色，让内容浏览更加高效有序。经过两年多的发展，51黑料网已成为中文互联网最具影响力的黑料导航入口之一，日均服务用户超过百万。我们始终坚持\"按区浏览、一手直达\"的服务理念，持续优化分区导航体验，为用户创造更优质的内容消费环境。',
};

export const indexData = {
  title: '专题索引',
  items: [
    { name: '2026年7月黑料一区专题汇总', count: '42篇', zone: '一区' },
    { name: '2026年7月黑料二区深度报道', count: '38篇', zone: '二区' },
    { name: '每日大赛7月获奖话题合集', count: '31篇', zone: '大赛' },
    { name: '2026上半年十大热门事件', count: '10篇', zone: '专题' },
    { name: '网红行业黑料年度报告', count: '25篇', zone: '一区' },
    { name: '直播平台数据透明度调查', count: '18篇', zone: '二区' },
    { name: '明星代言翻车事件全记录', count: '22篇', zone: '一区' },
    { name: '社交平台算法推荐机制研究', count: '15篇', zone: '二区' },
    { name: '每日大赛年度总冠军回顾', count: '12篇', zone: '大赛' },
  ],
};

export const updatesData = {
  title: '最新动态',
  items: [
    { date: '2026-07-29', time: '14:30', content: '一区更新：某头部主播涉嫌虚假宣传证据链整理完成', zone: '黑料一区' },
    { date: '2026-07-29', time: '11:15', content: '每日大赛第48期评选正式启动，本周话题池已开放', zone: '每日大赛' },
    { date: '2026-07-29', time: '09:00', content: '二区独家：某社交平台用户数据泄露事件最新进展', zone: '黑料二区' },
    { date: '2026-07-28', time: '16:45', content: '一区热点追踪：MCN机构合同纠纷涉事方首次回应', zone: '黑料一区' },
    { date: '2026-07-28', time: '13:20', content: '每日大赛第47期结果公布，查看完整获奖名单', zone: '每日大赛' },
    { date: '2026-07-28', time: '10:00', content: '二区深度分析：直播刷量产业链技术实现路径解密', zone: '黑料二区' },
    { date: '2026-07-27', time: '15:30', content: '网站公告：分区导航功能优化升级完成通知', zone: '站务公告' },
  ],
};

export const mediaData = {
  title: '视频集锦',
  items: [
    {
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20dark%20room%20with%20warm%20spotlight%20on%20vintage%20television%20screen%2C%20amber%20and%20copper%20toned%20lighting%2C%20retro%20broadcast%20studio%20atmosphere%2C%20film%20noir%20aesthetic%2C%20professional%20video%20production%20setup%2C%20dramatic%20shadows&width=800&height=450&seq=media-01&orientation=landscape',
      title: '【一区解说】某网红翻车事件全时间线还原',
      duration: '15:42',
      views: '32.6万',
      zone: '黑料一区',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Warm%20lit%20podcast%20recording%20studio%20with%20amber%20microphone%20and%20headphones%2C%20intimate%20interview%20setup%2C%20professional%20audio%20equipment%2C%20cozy%20dark%20acoustic%20panels%2C%20cinematic%20lighting%2C%20rich%20textures&width=800&height=450&seq=media-02&orientation=landscape',
      title: '【每日大赛】第47期冠军话题深度讨论',
      duration: '22:10',
      views: '28.1万',
      zone: '每日大赛',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Dark%20documentary%20interview%20setting%20with%20warm%20amber%20key%20light%2C%20professional%20camera%20rig%2C%20moody%20atmosphere%2C%20investigative%20journalism%20aesthetic%2C%20rich%20shadow%20detail%2C%20cinematic%20composition%20with%20subtle%20fill%20light&width=800&height=450&seq=media-03&orientation=landscape',
      title: '【二区调查】平台数据造假的技术幕后',
      duration: '18:35',
      views: '21.4万',
      zone: '黑料二区',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Professional%20dark%20broadcast%20control%20room%20with%20warm%20monitor%20glow%2C%20multiple%20screens%20displaying%20content%2C%20copper%20and%20brass%20accents%2C%20technical%20production%20environment%2C%20dramatic%20lighting%2C%20rich%20dark%20textures&width=800&height=450&seq=media-04&orientation=landscape',
      title: '【特别企划】2026上半年黑料大盘点',
      duration: '45:00',
      views: '45.8万',
      zone: '特别企划',
    },
  ],
};

export const carouselData = {
  title: '焦点专题',
  items: [
    {
      img: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20wide%20shot%20of%20dark%20archival%20library%20with%20warm%20golden%20spotlights%2C%20towering%20shelves%20of%20documents%2C%20dramatic%20rays%20of%20light%2C%20mysterious%20investigative%20atmosphere%2C%20professional%20film%20noir%20aesthetic%2C%20rich%20amber%20and%20copper%20tones&width=1200&height=600&seq=carousel-01&orientation=landscape',
      tag: '专题策划',
      title: '网红经济背后的隐秘链条：从孵化到变现全流程揭秘',
      desc: '独家深度调查报道，历时一个月整理，涵盖MCN运作模式、流量采购、数据优化等核心环节。',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Warm%20dramatic%20wide%20angle%20of%20newsroom%20with%20golden%20evening%20light%20streaming%20through%20windows%2C%20scattered%20newspapers%20and%20photographs%2C%20investigative%20journalism%20atmosphere%2C%20cinematic%20composition%2C%20rich%20textures%2C%20professional%20documentary%20style&width=1200&height=600&seq=carousel-02&orientation=landscape',
      tag: '热点追踪',
      title: '直播行业大洗牌：头部平台数据真实性质疑持续升级',
      desc: '跟踪报道两周，汇总多方信源交叉验证，揭示直播行业数据造假产业链的完整面貌。',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Atmospheric%20wide%20shot%20of%20dark%20archive%20vault%20with%20warm%20tungsten%20lighting%2C%20rows%20of%20filing%20cabinets%2C%20dramatic%20perspective%2C%20mysterious%20investigative%20mood%2C%20professional%20cinematic%20aesthetic%2C%20rich%20amber%20and%20shadow&width=1200&height=600&seq=carousel-03&orientation=landscape',
      tag: '深度调查',
      title: '社交平台算法推荐如何影响公众舆论：一项系统性研究',
      desc: '二区编辑团队联合多位业内人士，系统分析各平台推荐算法对内容分发和用户认知的深层影响。',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20composition%20of%20dark%20investigation%20room%20with%20cork%20board%20and%20red%20string%20connections%2C%20warm%20desk%20lamp%20lighting%2C%20photographs%20and%20documents%2C%20noir%20detective%20aesthetic%2C%20professional%20production%20design&width=1200&height=600&seq=carousel-04&orientation=landscape',
      tag: '独家报道',
      title: '明星代言翻车事件大盘点：2024-2026年完整回顾',
      desc: '统计两年间37起明星代言翻车事件，分析事件类型、品牌应对策略及行业影响。',
    },
    {
      img: 'https://readdy.ai/api/search-image?query=Warm%20epic%20wide%20view%20of%20dark%20broadcast%20studio%20with%20dramatic%20overhead%20lighting%2C%20professional%20camera%20equipment%2C%20production%20monitors%20glowing%20amber%2C%20cinematic%20atmosphere%2C%20rich%20dark%20textures%2C%20professional%20film%20set&width=1200&height=600&seq=carousel-05&orientation=landscape',
      tag: '特别企划',
      title: '每日大赛年度特辑：从话题到现象的影响力演变史',
      desc: '回顾每日大赛专区从创立至今的发展历程，见证一个社区话题如何演变为全网关注的现象级内容。',
    },
  ],
};